import ParentProfile from './ParentProfile';

export default ParentProfile;